export default "__VITE_ASSET__CcqKsWbk__"